import { createElement, PropTypes } from 'rlink-react';
import NavLink from 'rlink-router/NavLink';
import { targetEnum } from 'rlink-router/constants';
import RecruitingJob from 'rlink-recruiting/RecruitingJob';
import { EMPTY_DEPARTMENT_NAME } from 'rlink-recruiting/constants';

export default function CategorizedJobs ({category, jobs}) {
  return (
    <div className="group small-12 medium-6 large-4 columns">
      {category !== EMPTY_DEPARTMENT_NAME && (
        <h4 className="group-title">{category}</h4>
      )}
      <div>
        {jobs.map(job => (
          <div key={job.id} className="node node-job-position node-promoted node-teaser">
            <h5 className="node-title noline">{job.title}</h5>
            <div className="field field-name-field-text-location field-type-text field-label-hidden field-wrapper">{job.locationName}</div>
            <div className="field field-name-field-external-url field-type-link-field field-label-hidden field-wrapper">
              <NavLink href={job.url} targetType={targetEnum.new}>More Info →</NavLink>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

CategorizedJobs.propTypes = {
  category: PropTypes.string,
  jobs: PropTypes.arrayOf(PropTypes.instanceOf(RecruitingJob)),
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/CategorizedJobs.jsx